module.exports = __webpack_public_path__ + "img/service-three.3de1f7d6.png";